import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    urls: [], // Will now be array of { url, name, envId }
}

const urlSlice = createSlice({
    name: 'url',
    initialState,
    reducers: {
        setUrls: (state, action) => {
          
            state.urls = action.payload;
        },
        addUrl: (state, action) => {
           
            if (!state.urls.some(item => item.url === action.payload.url)) {
                state.urls.push(action.payload);
            }
        },
        removeUrl: (state, action) => {
           
            state.urls = state.urls.filter(item => item.url !== action.payload && item.envId !== action.payload);
        }
    },
});

export const { setUrls, addUrl, removeUrl } = urlSlice.actions;
export default urlSlice.reducer;